import * as React from "react";
import { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Button, TextField, FormHelperText } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
// import ModalSelectCover from "./ModalSelectCover"
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import { AutoComplete } from "antd";
// import { SuggestedMovies } from "../../../utils/utilsFunctions"
// import ProgressBar from "./ProgressBar"
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
// import SelectSubtitles from "./SelectSubtitles";
// import { uploadSubtitle } from "../../../../../validations/subtitlesFromValidation";
import { getInfoInfluencerApi, registerInfluencerApi, editInfoInfluencerApi, checkCodeForUseAcademyRegisterApi } from "../../../../../services/InfluencerApi";
import ErrorIcon from '@mui/icons-material/Error';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InfluencerInfo from "./InfluencerInfo"
import RegisterCode from "./RegisterCode"

const SERVER_URL = `${process.env.REACT_APP_SITEURL}`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function RegisterInfluencer({ handlesetInfluencerTabsValue }) {
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [initialMessage, setInitialMessage] = React.useState("لطفا صبر کنید");
  const [checkUserStatus, setCheckUserStatus] = React.useState("loading");
  const [editInfo, setEditInfo] = React.useState(false);
  const [editType, setEditType] = React.useState();
  const [influencerId, setInfluencerId] = useState("");
  const [name, setName] = useState("");
  const [activityPlaceArr, setActivityPlaceArr] = React.useState([]);
  const [activityPlace, setActivityPlace] = React.useState("");
  const [instagram, setInstagram] = React.useState("");
  const [telegram, setTelegram] = React.useState("");
  const [facebook, setFacebook] = React.useState("");
  const [twitter, setTwitter] = React.useState("");
  const [youtube, setYoutube] = React.useState("");
  const [otherPlace, setOtherPlace] = React.useState("");
  const [situationCode, setSituationCode] = React.useState("");
  const [situation, setSituation] = React.useState("");
  const [description, setDescription] = React.useState("");


  const checkChecked = (place) => {
    if (activityPlaceArr.indexOf(place) >= 0) return true
    else return false
  }

  const handleActivityPlace = (place, state) => {
    let cpActivityPlace = [...activityPlaceArr]
    if (state) {
      cpActivityPlace.push(place)
      setActivityPlaceArr(cpActivityPlace)
    } else {
      let findIndex = cpActivityPlace.indexOf(place)
      cpActivityPlace.splice(findIndex, 1);
      setActivityPlaceArr(cpActivityPlace)
    }
  }



  const initialValues = {
    name: "",
    activityPlaceArr: "",
    instagram: "",
    telegram: "",
    facebook: "",
    twitter: "",
    youtube: "",
    otherPlace: "",
    description: "",
  };


  const onSubmit = (values, props) => {
    if (!name) {
      customToastify("error", "لطفا نام خود را وارد کنید");
    } else {
      let newValues = {
        name,
        activityPlace: activityPlaceArr,
        instagram,
        telegram,
        facebook,
        twitter,
        youtube,
        otherPlace,
        description,
      };
      for (const item in newValues) {
        if (newValues[item] == "") delete newValues[item]
      }
      if (editType == "new") registerNewInfluencer(newValues)
      else if (editType == "already") {
        newValues["influencerId"] = influencerId
        editInfluencer(newValues)
      }
    }
  };

  const getPlaces = (places) => {
    let allPlaces = ""
    if (places.indexOf("teacher") >= 0) allPlaces += " استاد زبان ،"
    if (places.indexOf("socialNetwork") >= 0) allPlaces += " شبکه های اجتماعی ،"
    if (places.indexOf("academy") >= 0) allPlaces += " آموزشگاه ،"
    if (places.indexOf("other") >= 0) allPlaces += " دیگر موارد "
    return allPlaces
  }

  const getSituation = (situation) => {
    let st
    if (situation == "initialRegistration") st = "ثبت اولیه اطلاعات (آماده ثبت کد معرف)"
    if (situation == "awaitingConfirmation") st = "در انتظار تایید مدیریت"
    if (situation == "editedAndAwaitingConfirmation") st = "ویرایش شده و در انتظار تایید مدیریت"
    if (situation == "needForCheck") st = "لطفا اطلاعات  را ویرایش کنید"
    if (situation == "confirmed") st = "تایید شده"
    if (situation == "rejected") st = "عدم تایید - در صورت نیاز از بخش پشتیبانی پیامی به مدیریت سایت ارسال کنید"
    return st
  }
  const registerNewInfluencer = async (data) => {
    let toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await registerInfluencerApi(data);
      const resData = checkResponseData(response);
      if (resData["success"]) {
        let influencerInfo = resData["data"]["data"]
        if (influencerInfo[0]["name"]) {
          setInfluencerId(influencerInfo[0]["_id"])
          setEditType("already")
          setSituationCode(influencerInfo[0]["situation"])
          setSituation(getSituation(influencerInfo[0]["situation"]))
          setEditInfo(false)
        } else {
          setCheckUserStatus("loaded")
          setEditInfo(false)
          setEditType("already")
        }
        const msg = resData["message"] || "درخواست انجام شد"
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setInitialMessage(`${msg} برای ادامه کد همکاری را وارد نمایید`)
      } else {
        setCheckUserStatus("loaded")
        setEditInfo(false)
        customToastify("info", resData["message"] || "اتفاق غیر منتظره پیش آمده است");
        setInitialMessage(resData["message"] || "اتفاق غیر منتظره پیش آمده است")
      }
    } catch (error) {
      setCheckUserStatus("loaded")
      setEditInfo(false)
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      customToastify("info", errMsg || "مشکلی وجود دارد");
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
      setInitialMessage(errMsg || "مشکلی وجود دارد")
      console.error(error);
    }
  };

  const editInfluencer = async (data) => {
    let toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await editInfoInfluencerApi(data);
      const resData = checkResponseData(response);
      if (resData["success"]) {
        let influencerInfo = resData["data"]["data"]
        if (influencerInfo[0]["name"]) {
          setInfluencerId(influencerInfo[0]["_id"])
          setName(influencerInfo[0]["name"])
          setEditType("already")
          setSituationCode(influencerInfo[0]["situation"])
          setEditInfo(false)
        } else {
          setCheckUserStatus("loaded")
          setEditInfo(false)
          setEditType("already")
        }
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        setCheckUserStatus("loaded")
        setEditInfo(false)
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      setCheckUserStatus("loaded")
      setEditInfo(false)
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
      console.error(error);
    }
  };

  const getInitialInfo = async () => {
    try {
      const response = await getInfoInfluencerApi({});
      const resData = checkResponseData(response);
      if (resData["success"]) {
        let influencerInfo = resData["data"]["data"]
        if (influencerInfo[0]["name"]) {
          setInfluencerId(influencerInfo[0]["_id"])
          setName(influencerInfo[0]["name"])
          setActivityPlaceArr(influencerInfo[0]["activityPlace"])
          setActivityPlace(getPlaces(influencerInfo[0]["activityPlace"]))
          setInstagram(influencerInfo[0]["instagram"])
          setTelegram(influencerInfo[0]["telegram"])
          setFacebook(influencerInfo[0]["facebook"])
          setTwitter(influencerInfo[0]["twitter"])
          setYoutube(influencerInfo[0]["youtube"])
          setOtherPlace(influencerInfo[0]["otherPlace"])
          setSituationCode(influencerInfo[0]["situation"])
          setSituation(getSituation(influencerInfo[0]["situation"]))
          setDescription(influencerInfo[0]["description"])
          setCheckUserStatus("loaded")
          setEditType("already")
          setInitialMessage(null)
        } else {
          setCheckUserStatus("loaded")
          setInitialMessage("تا کنون درخواستی برای همکاری و ارتقای کاربری شما در سایت ثبت نشده است با کلیک بر روی دکمه زیر شروع کنید")
          setEditType("new")
        }
        // customToastify("info",resData["message"] || "اتفاق غیر منتظره پیش آمده است");
        // toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        // customToastify("info",resData["message"] || "اتفاق غیر منتظره پیش آمده است");
      }
    } catch (error) {
      // setsubtitleUploadPercent(101)
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      customToastify("info", errMsg || "مشکلی وجود دارد");
      // if(checkUserStatus=="loading") {
      //   setInitialMessage(errMsg || "مشکلی وجود دارد")

      // }
      // toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
      console.error(error);
    }
  };

  // const UploadSubtitlesApiRun = async (formData) => {
  //   // let toastMsg = toast.loading("لطفا صبر کنید...")
  //   try {
  //     const data = {};
  //     // const response = await UploadSubtitlesApi(formData, handleSubtitleUploadPercent);
  //     // const resData = checkResponseData(response);
  //     const resData = null
  //     if (resData["success"]) {
  //       let code = resData["data"]["data"][0]["subtitlesUploadId"]
  //       console.log("getSitePackagesListsuccess", code)
  //       setSubtitileCode(code)
  //       // customToastify("info",resData["message"] || "اتفاق غیر منتظره پیش آمده است");
  //       // toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
  //     } else {
  //       console.log("getSitePackagesListelde")
  //       setsubtitleUploadPercent(101)
  //       // customToastify("info",resData["message"] || "اتفاق غیر منتظره پیش آمده است");
  //     }
  //   } catch (error) {
  //     setsubtitleUploadPercent(101)
  //     const errData = checkErrorMessage(error);
  //     let errMsg = errData["titles"] || errData["message"]
  //     customToastify("info",errMsg || "مشکلی وجود دارد");
  //     // toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 5000 });
  //     console.error(error);
  //   }
  // };

  React.useEffect(() => {
    getInitialInfo()
  }, [])

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        {!editInfo ?
          <Paper sx={{ py: 2, textAlign: "center" }}>
            {initialMessage}
            <br />
            {checkUserStatus == "loaded" ? <>
              <Button variant="outlined" sx={{ m: 1 }} disabled={situationCode == "confirmed" || situationCode == "rejected"} onClick={() => { setEditInfo(true) }}>
                ویرایش یا ثبت مشخصات
              </Button>
              <br />
              {editType == "already" ? <RegisterCode handlesetInfluencerTabsValue={handlesetInfluencerTabsValue} influencerId={influencerId} situationCode={situationCode} /> : null}
              <InfluencerInfo name={name} activityPlace={activityPlace} instagram={instagram} telegram={telegram} facebook={facebook} twitter={twitter} youtube={youtube} otherPlace={otherPlace} situation={situation} description={description} />
            </> : null}
          </Paper>
          :
          <Formik
            initialValues={initialValues}
            // validationSchema={uploadSubtitle}
            onSubmit={onSubmit}
          >
            {(props) => (
              <Form>
                <Paper sx={{ textAlign: "center" }}>
                  <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell
                            sx={{ width: detectSize600px ? "25%" : "50%" }}
                          ></StyledTableCell>
                          <StyledTableCell
                            sx={{ width: detectSize600px ? "75%" : "50%" }}
                          >
                            {" "}
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {"نام"}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <Field
                              type="text"
                              size="small"
                              as={TextField}
                              name="name"
                              label="نام"
                              placeholder="نام"
                              value={name}
                              onChange={(e) => {
                                setName(e.target.value);
                                // handleSetFieldValues(
                                //   props,
                                //   "name",
                                //   e.target.value
                                // );
                              }}
                            />
                            <FormHelperText
                              sx={{
                                m: 0,
                                p: 0,
                                color: "#f96767",
                                textAlign: "center",
                              }}
                            >
                              <ErrorMessage name="name" />
                            </FormHelperText>
                          </StyledTableCell>
                        </StyledTableRow>

                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {"محل فعالیت"}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <FormControl style={{ minWidth: 170 }}>
                              <FormGroup >
                                <FormControlLabel onChange={(e) => { handleActivityPlace("teacher", e.target.checked) }} control={<Checkbox checked={checkChecked("teacher")} />} label="استاد زبان" />
                                <FormControlLabel onChange={(e) => { handleActivityPlace("socialNetwork", e.target.checked) }} control={<Checkbox checked={checkChecked("socialNetwork")} />} label="شبکه های اجتماعی" />
                                <FormControlLabel onChange={(e) => { handleActivityPlace("academy", e.target.checked) }} control={<Checkbox checked={checkChecked("academy")} />} label="آموزشگاه زبان" />
                                <FormControlLabel onChange={(e) => { handleActivityPlace("other", e.target.checked) }} control={<Checkbox checked={checkChecked("other")} />} label="دیگر موارد" />
                              </FormGroup>
                              <FormHelperText
                                sx={{ color: "#f96767", textAlign: "center" }}
                              >
                                <ErrorMessage name="activityPlaceArr" />
                              </FormHelperText>
                            </FormControl>
                          </StyledTableCell>
                        </StyledTableRow>


                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {"آدرس پیج اینستاگرام"}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <Field
                              type="text"
                              size="small"
                              as={TextField}
                              name="instagram"
                              label="instagram"
                              placeholder="instagram"
                              value={instagram}
                              onChange={(e) => {
                                setInstagram(e.target.value);
                                // handleSetFieldValues(
                                //   props,
                                //   "name",
                                //   e.target.value
                                // );
                              }}
                            />
                            <FormHelperText
                              sx={{
                                m: 0,
                                p: 0,
                                color: "#f96767",
                                textAlign: "center",
                              }}
                            >
                              <ErrorMessage name="instagram" />
                            </FormHelperText>
                          </StyledTableCell>
                        </StyledTableRow>

                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {"آدرس پیج تلگرام"}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <Field
                              type="text"
                              size="small"
                              as={TextField}
                              name="telegram"
                              label="telegram"
                              placeholder="telegram"
                              value={telegram}
                              onChange={(e) => {
                                setTelegram(e.target.value);
                                // handleSetFieldValues(
                                //   props,
                                //   "name",
                                //   e.target.value
                                // );
                              }}
                            />
                            <FormHelperText
                              sx={{
                                m: 0,
                                p: 0,
                                color: "#f96767",
                                textAlign: "center",
                              }}
                            >
                              <ErrorMessage name="telegram" />
                            </FormHelperText>
                          </StyledTableCell>
                        </StyledTableRow>

                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {"آدرس صفحه فیس بوک"}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <Field
                              type="text"
                              size="small"
                              as={TextField}
                              name="facebook"
                              label="facebook"
                              placeholder="facebook"
                              value={facebook}
                              onChange={(e) => {
                                setFacebook(e.target.value);
                                // handleSetFieldValues(
                                //   props,
                                //   "name",
                                //   e.target.value
                                // );
                              }}
                            />
                            <FormHelperText
                              sx={{
                                m: 0,
                                p: 0,
                                color: "#f96767",
                                textAlign: "center",
                              }}
                            >
                              <ErrorMessage name="facebook" />
                            </FormHelperText>
                          </StyledTableCell>
                        </StyledTableRow>

                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {"آدرس صفحه توییتر"}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <Field
                              type="text"
                              size="small"
                              as={TextField}
                              name="twitter"
                              label="twitter"
                              placeholder="twitter"
                              value={twitter}
                              onChange={(e) => {
                                setTwitter(e.target.value);
                                // handleSetFieldValues(
                                //   props,
                                //   "name",
                                //   e.target.value
                                // );
                              }}
                            />
                            <FormHelperText
                              sx={{
                                m: 0,
                                p: 0,
                                color: "#f96767",
                                textAlign: "center",
                              }}
                            >
                              <ErrorMessage name="twitter" />
                            </FormHelperText>
                          </StyledTableCell>
                        </StyledTableRow>

                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {"آدرس صفحه یوتیوب"}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Field
                              type="text"
                              size="small"
                              as={TextField}
                              name="youtube"
                              label="youtube"
                              placeholder="youtube"
                              value={youtube}
                              onChange={(e) => {
                                setYoutube(e.target.value);
                                // handleSetFieldValues(
                                //   props,
                                //   "name",
                                //   e.target.value
                                // );
                              }}
                            />
                            <FormHelperText
                              sx={{
                                m: 0,
                                p: 0,
                                color: "#f96767",
                                textAlign: "center",
                              }}
                            >
                              <ErrorMessage name="youtube" />
                            </FormHelperText>
                          </StyledTableCell>
                        </StyledTableRow>

                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {"دیگر شبکه های اجتماعی"}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <Field
                              type="text"
                              size="small"
                              as={TextField}
                              name="otherPlace"
                              label="دیگر شبکه های اجتماعی"
                              placeholder="دیگر شبکه های اجتماعی"
                              value={otherPlace}
                              onChange={(e) => {
                                setOtherPlace(e.target.value);
                                // handleSetFieldValues(
                                //   props,
                                //   "name",
                                //   e.target.value
                                // );
                              }}
                            />
                            <FormHelperText
                              sx={{
                                m: 0,
                                p: 0,
                                color: "#f96767",
                                textAlign: "center",
                              }}
                            >
                              <ErrorMessage name="otherPlace" />
                            </FormHelperText>
                          </StyledTableCell>
                        </StyledTableRow>

                        <StyledTableRow>
                          <StyledTableCell component="th" scope="row">
                            {"دیگر توضیحات"}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <Field
                              type="text"
                              size="small"
                              as={TextField}
                              multiline
                              rows={4}
                              name="description"
                              label="دیگر توضیحات"
                              placeholder="دیگر توضیحات"
                              value={description}
                              onChange={(e) => {
                                setDescription(e.target.value);
                                // handleSetFieldValues(
                                //   props,
                                //   "name",
                                //   e.target.value
                                // );
                              }}
                            />
                            <FormHelperText
                              sx={{
                                m: 0,
                                p: 0,
                                color: "#f96767",
                                textAlign: "center",
                              }}
                            >
                              <ErrorMessage name="description" />
                            </FormHelperText>
                          </StyledTableCell>
                        </StyledTableRow>

                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Button type="submit" variant="contained" sx={{ my: 1 }}>
                    ثبت و ذخیره
                  </Button>
                </Paper>
              </Form>
            )}
          </Formik>}

      </Box>
    </Grid>
  );
}
